import { RouterPath } from '@/routes/RouterPath';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Splash = () => {
    const navigate = useNavigate();
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        setFadeOut(false);
        
        const timer = setTimeout(() => {
            setFadeOut(true);
            setTimeout(() => {
                navigate(RouterPath.LOGIN);
            }, 1500);
        }, 500);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className={`wrap no-bg ${fadeOut ? 'fade-out' : ''}`}>
            <div className="container">
                <div className="spls-img"><img src="img/0.SPLS_1.png" alt="spls" /></div>
            </div>
        </div>
    )
}

export default Splash;